import { useTranslation } from "react-i18next";

import {
  MobileSortBottomSheet,
  SortOption,
} from "../../ClientPage/Common/controls/MobileSortBottomSheet";
import { useIsMobile } from "../../hooks";
import { Typo } from "../../Typo";
import { useLeadsContextV2 } from "../providers/LeadsProviderV2";
import { ReturnedTranslatedContentLeadPageHook } from "../types";

type LeadsSortV2Props = {
  translations: ReturnedTranslatedContentLeadPageHook;
  isBackoffice?: boolean;
};

export const LeadsSortV2 = ({
  translations,
  isBackoffice,
}: LeadsSortV2Props) => {
  const {
    state: { sortBy, sortOrder },
    actions: { setSort },
    runResource,
  } = useLeadsContextV2();
  const isMobile = useIsMobile();

  const { translatedContent } = translations;
  const { t } = useTranslation();

  const { columnLabels } = translatedContent;
  const sortOptions: SortOption[] = [
    {
      id: "tDate",
      label: columnLabels?.signupDateColumnLabel ?? "",
    },
    {
      id: "tStatus",
      label: columnLabels?.onboardingStatusColumnLabel ?? "",
    },
    {
      id: "tCountry",
      label: columnLabels?.countryColumnLabel ?? "",
    },
  ];

  const getOrderLabels = (sortById: string) => {
    switch (sortById) {
      case "tDate":
        return {
          descLabel: t("leadsPage_sort_tDate_desc"),
          ascLabel: t("leadsPage_sort_tDate_asc"),
        };
      case "tStatus":
        return {
          descLabel: t("leadsPage_sort_tStatus_desc"),
          ascLabel: t("leadsPage_sort_tStatus_asc"),
        };
      case "tCountry":
        return {
          descLabel: t("leadsPage_sort_tCountry_desc"),
          ascLabel: t("leadsPage_sort_tCountry_asc"),
        };
      default:
        return { descLabel: "", ascLabel: "" };
    }
  };

  if (!isMobile) {
    return null;
  }

  return (
    <div className="pt-4">
      <div className="flex h-10 items-center justify-between">
        <MobileSortBottomSheet
          sortOptions={sortOptions}
          selectedSortBy={sortBy ?? "tDate"}
          selectedSortOrder={sortOrder ?? "desc"}
          onApply={(newSortBy, newSortOrder) =>
            setSort(newSortBy, newSortOrder)
          }
          getOrderLabels={getOrderLabels}
        />
        {!isBackoffice && (
          <div className="flex flex-row items-center">
            <button
              onClick={() => runResource("csv")}
              className="flex min-h-[40px] min-w-[80px] cursor-pointer items-center justify-center whitespace-nowrap rounded-lg bg-surface-tonal-default px-3 py-2"
            >
              <Typo type="labelSM">{translatedContent.exportCSVText}</Typo>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
